import { rem } from "@mantine/core"
import { useClipboard } from "@mantine/hooks"
import { IconCheck, IconCopy } from "@tabler/icons-react"

import { Button, ButtonProps } from "../../../atoms/Button/Button"
import { getIconButtonSize } from "../../../utils/icon.utils"

import classes from "./CopyButton.module.css"

type CopyButtonProps = {
  copyableText: string
  admin?: boolean
  title?: string
  label?: string
} & Omit<ButtonProps, "children">

export const CopyButton = ({
  copyableText,
  admin,
  label,
  size,
  title,
  ...props
}: CopyButtonProps) => {
  const clipboard = useClipboard()
  return (
    <Button
      size={size}
      variant={admin ? "admin-tertiary" : "secondary"}
      toolTip={label ?? undefined}
      classNames={classes}
      rightSection={
        clipboard.copied ? (
          <IconCheck style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
        ) : (
          <IconCopy style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
        )
      }
      onClick={() => clipboard.copy(copyableText)}
      {...props}
    >
      {title ? title : copyableText}
    </Button>
  )
}

export const CopyButtonWithoutTitle = ({
  copyableText,
  admin,
  label,
  size = "sm",
  title: _title,
  ...props
}: CopyButtonProps) => {
  const clipboard = useClipboard()
  const iconSize = getIconButtonSize(size)
  return (
    <Button
      size={size}
      variant={admin ? "admin-tertiary" : "secondary"}
      toolTip={label ?? undefined}
      classNames={classes}
      className={classes.withoutText}
      onClick={() => clipboard.copy(copyableText)}
      {...props}
    >
      {clipboard.copied ? (
        <IconCheck style={{ ...iconSize }} stroke={1.5} />
      ) : (
        <IconCopy style={{ ...iconSize }} stroke={1.5} />
      )}
    </Button>
  )
}
